import wbsBookingsApi from '../apis/wbsBookingsApi';

const deleteSpotAvatarsService = async (spotId: string): Promise<void> => {
  await wbsBookingsApi.delete(`/avatars/spots/${spotId}`);
};

export default deleteSpotAvatarsService;
